import {
  CLASSE_ESTADO,
  ROTULO_ESTADO,
  faixaDaIdade,
  type EstadoAcompanhamento,
} from "@/modules/visitantes/utils/regras";

const BASE = "inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-bold";

/** "Jovem · 24 anos" — a cor vem da faixa; a faixa é sempre calculada, nunca digitada. */
export function SeloFaixa({ idade }: { idade: number | null }) {
  if (idade === null)
    return <span className={`${BASE} bg-surface-2 text-muted`}>Sem data de nascimento</span>;
  const faixa = faixaDaIdade(idade);
  return (
    <span className={`${BASE} ${faixa.classe}`}>
      {faixa.rotulo} · {idade} {idade === 1 ? "ano" : "anos"}
    </span>
  );
}

export function SeloEstado({ estado }: { estado: EstadoAcompanhamento }) {
  return <span className={`${BASE} ${CLASSE_ESTADO[estado]}`}>{ROTULO_ESTADO[estado]}</span>;
}

export function SeloTexto({
  children,
  tom = "neutro",
}: {
  children: string;
  tom?: "neutro" | "aviso" | "ok" | "perigo";
}) {
  const classe = {
    neutro: "bg-surface-2 text-muted",
    aviso: "bg-warning/15 text-warning",
    ok: "bg-success/15 text-success",
    perigo: "bg-danger/10 text-danger",
  }[tom];
  return <span className={`${BASE} ${classe}`}>{children}</span>;
}
